import { render, staticRenderFns } from "./UserLogs.vue?vue&type=template&id=962116fa&"
import script from "./UserLogs.vue?vue&type=script&lang=js&"
export * from "./UserLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports